var _rect, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackgroundLines(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 195,
    viewBox: "0 0 180 195",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 165.696,
    y: -5.71086,
    width: 40.0295,
    height: 197.924,
    rx: 20.0147,
    transform: "rotate(60 165.696 -5.71086)",
    fill: "#F8F8FA",
    stroke: "#208C72",
    strokeWidth: 1.88743
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 136.835,
    y: 59.3516,
    width: 40.0295,
    height: 140.398,
    rx: 20.0147,
    transform: "rotate(60 136.835 59.3516)",
    fill: "#F8F8FA",
    stroke: "#208C72",
    strokeWidth: 1.88743
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 115.164,
    width: 40.0295,
    height: 101.376,
    rx: 20.0147,
    transform: "rotate(60 124 115.164)",
    fill: "#F8F8FA",
    stroke: "#208C72",
    strokeWidth: 1.88743
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundLines);
export default __webpack_public_path__ + "static/media/background-lines.04500462be6a3c76346aad1e00277acd.svg";
export { ForwardRef as ReactComponent };